import { makeAutoObservable } from 'mobx';
import { AffiliateStatisticDto } from '../../../../defs/api';
import { InvoicePaymentsCountDetailMobxDto } from '../invoice/invoice-payments-count-detail-mobx-dto';

export class AffiliateStatisticMobxDto implements AffiliateStatisticDto {
    commissions: number = 0;

    paymentsCount: number = 0;

    paymentsCountDetail?: InvoicePaymentsCountDetailMobxDto;

    registrationsCount: number = 0;

    canceledSubscriptionsCount: number = 0;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: AffiliateStatisticDto): AffiliateStatisticMobxDto {
        const mobxDto = new AffiliateStatisticMobxDto();
        return Object.assign(mobxDto, dto, {
            paymentsCountDetail: dto.paymentsCountDetail
                ? InvoicePaymentsCountDetailMobxDto.create(dto.paymentsCountDetail)
                : undefined,
        });
    }

    static createFromArray(dtos: AffiliateStatisticDto[]): AffiliateStatisticMobxDto[] {
        return dtos.map((dto) => AffiliateStatisticMobxDto.create(dto));
    }
}
